<template>
  <Modal appear variant="info" @close="close">
    <template slot="lead">
      <span class="c-text--main">SEARCH WRITE デモサイトへようこそ！</span>
    </template>
    <template slot="content">
      <div class="c-text--free c-text--left">
        <h4 class="c-text--left">
          本デモサイトでは、実際の画面を使ってSEARCH
          WRITEの機能を体験いただけます。<br />表示されているデータはサンプルです。キーワード、URL、数値などは架空のものとなっており、<br />データの登録や変更・削除は行えません。また、一部の機能のご利用を制限しています。
        </h4>
        <dl>
          <dd>
            <ul>
              <li>・ユーザー情報の変更や認証に関わる機能</li>
              <li>・契約・請求に関わる機能</li>
              <li>
                ・最近の新機能やアップデート(のちほどデモサイトに反映しますので、しばらくお待ちください)
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal';

export default {
  components: {
    Modal
  },

  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
